import React, { useState, useRef } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import TrainingCourseBlock from './TrainingCourseBlock';
import { leftArrow, rightArrow } from '../../../constants/icons';

function TrainingCourseCarousel({ coursedetails }) {

  const ref = useRef(null);
  const [selectedItem, setSelectedItem] = useState(null);

  const handleNextSlide = () => {
    ref.current.slickNext();
  };

  const handlePrevSlide = () => {
    ref.current.slickPrev();
  };

  const handleClick = (item) => {
    let trainingCourseSingle = {};
    trainingCourseSingle['course'] = item;
    const selectedCourse = coursedetails.training_course_details.find(course => course.id === item.id);
    trainingCourseSingle['course'] = { ...item, slug: selectedCourse.bbc_slug };
    window.location.href = `/${trainingCourseSingle['course']['slug']}`;
  };

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    variableWidth: true,
    adaptiveHeight: true,
  };

  return (
    <>
      {/* <div className="mk-bundle-courses mk-scroll-horizontal carousel-course-bundle mk-res-bundle-courses"> */}
        {coursedetails?.bundle?.c_training_courses &&
          JSON.parse(coursedetails.bundle.c_training_courses).map((trainingCourseDetail, i) => {
            return (
              <div key={trainingCourseDetail.id} className={
                JSON.stringify(trainingCourseDetail) ===
                JSON.stringify(selectedItem?.course)
                  ? 'mk-bundle-course active'
                  : 'mk-bundle-course'
              }>
                <TrainingCourseBlock
                  className={
                    JSON.stringify(trainingCourseDetail) ===
                    JSON.stringify(selectedItem?.course)
                      ? 'active'
                      : ''
                  }
                  trainingCourseDetails={trainingCourseDetail}
                  onClick={() => handleClick(trainingCourseDetail)}
                />
              </div>
            );
          })}
      {/* </div> */}
      <div className="carousel-action">
        <a href="#" className="btn-move btn-prev" onClick={handlePrevSlide}>
          {leftArrow}
        </a>{' '}
        <a href="#" className="btn-move btn-next" onClick={handleNextSlide}>
          {rightArrow}
        </a>
      </div>
      {selectedItem && (
        <>
        </>
      )}
    </>
  );
}

export default TrainingCourseCarousel;
